<app-modal-filler-atom
  (click)="close()"
  [index]="(index$ | async) ?? 0"
></app-modal-filler-atom>
<div
  class="fixed bottom-0 left-0 right-0 mx-auto max-h-[85vh] overflow-y-auto"
  [style.z-index]="((index$ | async) ?? 0) + 50"
>
  <div class="w-full rounded-t-3xl bg-white px-8 pb-10 pt-8">
    <div class="flex items-start justify-between gap-6">
      <div>
        <h2 class="text-4xl font-bold text-neutral-900">
          {{ 'kiosk.currency.modal-title' | translate }}
        </h2>
        <p class="mt-2 text-xl text-neutral-500">
          {{
            'kiosk.currency.modal-subtitle'
              | translate: { currency: baseCurrencyName(), code: baseCurrencyCode() }
          }}
        </p>
      </div>
      <button
        type="button"
        class="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-neutral-100 text-3xl text-neutral-700"
        [attr.aria-label]="'kiosk.currency.close' | translate"
        (click)="close()"
      >
        ×
      </button>
    </div>

    @if (displayCurrency.loading()) {
      <p class="mt-8 text-xl text-neutral-500">{{ 'kiosk.currency.loading' | translate }}</p>
    }

    @if (displayCurrency.loadError()) {
      <p class="mt-8 text-xl text-neutral-600">{{ 'kiosk.currency.load-error' | translate }}</p>
    }

    <div class="mt-8 grid grid-cols-3 gap-4">
      <button
        type="button"
        class="col-span-3 flex items-center justify-between rounded-2xl border px-6 py-5 text-left"
        [class.border-2]="isSelected(null)"
        [class.border-neutral-900]="isSelected(null)"
        [class.bg-neutral-100]="isSelected(null)"
        [class.border-neutral-200]="!isSelected(null)"
        (click)="select(null)"
      >
        <span>
          <span class="block text-2xl font-bold text-neutral-900">{{ baseCurrencyCode() }}</span>
          <span class="block text-lg text-neutral-500">{{ baseCurrencyName() }}</span>
        </span>
        <span class="text-lg text-neutral-500">{{
          'kiosk.currency.local-currency' | translate
        }}</span>
      </button>

      @for (rate of displayCurrency.orderedRates(); track rate.code) {
        <button
          type="button"
          class="rounded-2xl border px-5 py-4 text-left"
          [class.border-2]="isSelected(rate.code)"
          [class.border-neutral-900]="isSelected(rate.code)"
          [class.bg-neutral-100]="isSelected(rate.code)"
          [class.border-neutral-200]="!isSelected(rate.code)"
          (click)="select(rate.code)"
        >
          <span class="block text-2xl font-bold text-neutral-900">{{ rate.code }}</span>
          <span class="block text-lg text-neutral-500">{{ rate.description }}</span>
        </button>
      }
    </div>

    @if (rateDateLabel()) {
      <p class="mt-8 text-lg text-neutral-500">
        {{ 'kiosk.currency.rate-footnote' | translate: { date: rateDateLabel() } }}
      </p>
    }
  </div>
</div>
